import React, { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = () =>
    api.get("/site-settings").then((r) => setSettings(r.data)).catch(() => setSettings(null));

  useEffect(() => {
    refresh();
  }, []);

  const waNumber = (settings && settings.whatsapp_number) || "6281214216628";
  const waDisplay = (settings && settings.whatsapp_display) || "0812-1421-6628";
  const waUrl = `https://wa.me/${waNumber}`;

  return (
    <SettingsContext.Provider value={{ settings, refresh, waNumber, waDisplay, waUrl }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
